/**
 * Include your custom JavaScript here.
 *
 * Theme hooks (unchanged from Warehouse):
 *   document.addEventListener('variant:changed', e => e.detail.variant)
 *   document.addEventListener('product:added', e => e.detail.variant / e.detail.quantity)
 *   dispatch 'product:added' or 'cart:refresh' on documentElement to refresh the mini-cart.
 */

/* ---------------------------------------------------------------------------
 * Size / width "pick-an-option" gate  (rewritten 10-23)
 * ---------------------------------------------------------------------------
 * Hides Add to Cart (CSS: .Pre_hide_primary_button { display:none }) and shows the
 * "Select a size / Select a width" prompt until the shopper has picked both.
 *
 * Old version bug: it set `window.onload = ...` to hide the button. window.onload
 * fires only after EVERY image/iframe/app finishes (~14s on desktop PDPs vs ~5s for
 * DOM-ready). A shopper who picked size + width inside that window had Add to Cart
 * shown by the click handler and then hidden again by onload, with the prompt
 * already hidden — leaving only the Shop Pay button. The gate also tracked state
 * through click-target classes instead of what was actually selected.
 *
 * This version derives the gate from the radios' real :checked state, every time,
 * so timing, click target, keyboard selection, and browser form-restore can't
 * desync it. It runs at DOM-ready (no window.onload) and on every option change.
 *
 * Contract kept for snippets/sticky-atc-bar.liquid: the gate is expressed as the
 * Add to Cart button's inline `display` and the prompt's text/inline `display`.
 * ------------------------------------------------------------------------- */
(function () {
  var SELECT_SIZE = 'Select a size';
  var SELECT_WIDTH = 'Select a width';

  function radiosIn(form, labelClass) {
    var labels = form.querySelectorAll('label.block-swatch__item.' + labelClass);
    var out = [];
    for (var i = 0; i < labels.length; i++) {
      var r = labels[i].htmlFor && document.getElementById(labels[i].htmlFor);
      if (r) out.push(r);
    }
    return out;
  }

  function anyChecked(radios) {
    for (var i = 0; i < radios.length; i++) if (radios[i].checked) return true;
    return false;
  }

  function setDisplay(nodes, value) {
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].style.display !== value) nodes[i].style.display = value;
    }
  }

  function syncForm(form) {
    var primary = form.querySelectorAll('.Pre_hide_primary_button');
    var prompts = form.querySelectorAll('.post_hide_button');
    if (!primary.length) return; // pre-order / sold-out / contact: no gate

    var sizes = radiosIn(form, 'click_size_varient');
    var widths = radiosIn(form, 'click_width_varient');

    var sizeOk = !sizes.length || anyChecked(sizes);
    var widthOk = !widths.length || anyChecked(widths);

    if (sizeOk && widthOk) {
      setDisplay(primary, 'block');
      setDisplay(prompts, 'none');
      return;
    }

    for (var i = 0; i < prompts.length; i++) {
      var p = prompts[i];
      // Keep the Liquid-rendered (translated, e.g. /es) "select size" text.
      if (!p.hasAttribute('data-size-text')) {
        p.setAttribute('data-size-text', p.textContent.trim() || SELECT_SIZE);
      }
      var text = !sizeOk ? p.getAttribute('data-size-text') : SELECT_WIDTH;
      if (p.textContent.trim() !== text) p.textContent = text;
    }
    setDisplay(primary, 'none');
    setDisplay(prompts, 'block');
  }

  function syncAll() {
    var forms = document.querySelectorAll('form.product-form');
    for (var i = 0; i < forms.length; i++) syncForm(forms[i]);
  }

  // Any option pick (mouse, touch, keyboard) fires `change` on the radio.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('block-swatch__radio')) {
      var form = t.closest('form.product-form');
      if (form) syncForm(form);
    }
  });

  // Back/forward cache restores form state without re-running scripts.
  window.addEventListener('pageshow', syncAll);

  // Theme-editor section reloads.
  document.addEventListener('shopify:section:load', syncAll);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll);
  } else {
    syncAll();
  }
})();
